<script lang="ts" setup>
import {onMounted, ref} from "vue";

const form = ref<HTMLDivElement | null>()
const changeFields = ref(new Set<string>([]))

const props = withDefaults(defineProps<{ personalData?: boolean, needInit?: boolean }>(), {
  personalData: false,
  needInit: true
})

onMounted(() => {
  const _form = form.value?.querySelector('form');

  if (props.needInit) {
    // @ts-ignore
    window.Formie.initForm(_form);
  }

  _form?.addEventListener('onBeforeFormieSubmit', async (e) => {
    ((e.target as HTMLFormElement).querySelectorAll('[data-custom=true]') as NodeListOf<HTMLInputElement>).forEach((node: HTMLInputElement) => {
      if (node.name === 'phone[number]') {
        node.name = 'phone';
      }

      if (!node.name.includes('fields[')) {
        changeFields.value.add(node.name);

        node.name = `fields[${node.name}]`;
      }
    });
  });

  if (!props.personalData) {
    return
  }

  _form?.addEventListener('onAfterFormieSubmit', (e: Event | CustomEvent) => {
    e.preventDefault();

    const user = (e as CustomEvent).detail.user

    for (const field in user) {
      const input = _form.querySelector(`[name='fields[${field}]']`) ?? _form.querySelector(`[name=${field}]`)

      if (!input) {
        continue
      }

      input.setAttribute('value', user[field])
    }
  });
})
</script>

<template>
  <div ref="form">
    <slot/>
  </div>
</template>